import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { MagicLinkUserRepository } from '../infra/MagicLinkUserRepository'

export type SaveMagicLinkTokenFactoryDependencies = {
  repository: MagicLinkUserRepository
}

export function saveMagicLinkTokenFactory({ repository }: SaveMagicLinkTokenFactoryDependencies) {
  return function saveMagicLinkTokenImpl(token: string) {
    repository.setLocalToken(token)
  }
}

export function saveMagicLinkToken(token: string) {
  const storage = new LocalStorageClient()
  const repository = new MagicLinkUserRepository({ storage })
  const saveToken = saveMagicLinkTokenFactory({ repository })

  return saveToken(token)
}
